import { render, staticRenderFns } from "./CloseoutCreatePage.vue?vue&type=template&id=fbf45f8c&scoped=true&"
import script from "./CloseoutCreatePage.vue?vue&type=script&lang=js&"
export * from "./CloseoutCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./CloseoutCreatePage.vue?vue&type=style&index=0&id=fbf45f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf45f8c",
  null
  
)

export default component.exports